import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import TeacherTable from "./Component/TeacherTable"


const Teacher =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TeacherTable />
            
        </div>
        <Footer />
        </>
    )
}

export default Teacher